import React, { Component } from 'react';

class PresetsList extends Component {

    render() {
        return (            
            <div className="presets-slider">
            {this.props.presets.map(preset => {
                return (
                <div
                    className="preset"
                    key={preset.id}
                    onClick={() => this.props.usePreset(preset.id)}
                >
                    <span className="command">/{preset.command}</span><span className="body">{preset.body}</span>
                </div>
                )
            })}
            </div>
        )
    }
}
export default PresetsList;